const { InspectorControls } = wp.blockEditor;
const { PanelBody, SelectControl, ToggleControl, RangeControl } = wp.components;
import CommonPanel from '../wp-controlers/common-panel';

const Inspector = ({ attributes, setAttributes }) => {
  const { scrollable, size, vAlign, hAlign } = attributes;

  return (
    <InspectorControls>
      <PanelBody title="Atributos do Bloco" initialOpen={true}>
        <ToggleControl
          label="Área Scrolável?"
          checked={scrollable}
          onChange={() => setAttributes({ scrollable: !scrollable })}
        />

        <RangeControl
          label="Quantidade de Items:"
          initialPosition={size}
          value={size}
          onChange={(value) => setAttributes({ size: value })}
          min={1}
          max={12}
        />

        <SelectControl
          label="Alinhamento vertical dos itens"
          value={vAlign}
          options={[
            {
              label: 'Topo',
              value: 'v-top',
            },
            {
              label: 'Centro',
              value: 'v-center',
            },
            {
              label: 'Fundo',
              value: 'v-bottom',
            },
          ]}
          onChange={(position) => setAttributes({ vAlign: position })}
        />

        <SelectControl
          label="Alinhamento horizontal dos itens"
          value={hAlign}
          options={[
            {
              label: 'Esquerda',
              value: 'h-start',
            },
            {
              label: 'Centro',
              value: 'h-center',
            },
            {
              label: 'Justificado',
              value: 'h-between',
            },
          ]}
          onChange={(position) => setAttributes({ hAlign: position })}
        />
      </PanelBody>

      <CommonPanel attributes={attributes} setAttributes={setAttributes} />
    </InspectorControls>
  );
};

export default Inspector;
